import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { handleToggleConsentLanguage, setLanguage } from '../../../store/consentSlice.slice';
import { RootState } from '../../../reducers';

const ToggleLanguage: React.FC = () => {
    const dispatch = useAppDispatch();
    const { language } = useSelector((state: RootState) => state.consentSlice);

    const handleToggleSpanish = (event: React.SyntheticEvent, newValue: string) => {
        dispatch(handleToggleConsentLanguage(newValue));
    };
    return (
        <Box my={2} textAlign={'center'}>
            <ToggleButtonGroup color="primary" value={language} exclusive onChange={handleToggleSpanish} aria-label="Platform">
                <ToggleButton value="english">English</ToggleButton>
                <ToggleButton value="spanish">Spanish</ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default ToggleLanguage;
